// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectEdit_container__1tOmq","actionContainer":"ProjectEdit_actionContainer__3iVA7"};